import { Container } from '@chakra-ui/react';
import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { LayoutCenteringVStack } from '../../../../components/Layout/LayoutCenteringVStack';
import ScrollToTopOnMount from '../../../../components/Layout/ScrollToTopOnMount';
import { BlockerCard } from '../../../../components/shared/BlockerCard/BlockerCard';
import { routes } from '../../../../routes/routesConfig';
import { ModelProfilePageLayout } from '../ModelProfilePageLayout/ModelProfilePageLayout';

export const ModelProfileSimpleInfoPage: React.FC<{
  image: string;
  heading: string;
  description: string;
  buttonText: string;
  imgAlt: string;
}> = ({ image, heading, description, buttonText, imgAlt }) => {
  const history = useHistory();
  return (
    <ModelProfilePageLayout>
      <ScrollToTopOnMount />
      <Container maxW={'container.xl'} px={0} py={{ base: 4, lg: 8 }}>
        <LayoutCenteringVStack>
          <BlockerCard
            isBordered
            image={image}
            imageAlt={imgAlt}
            heading={heading}
            text={description}
            primaryButtonText={buttonText}
            onClickPrimary={() => history.replace(routes.wizardProfile.path)}
          />
        </LayoutCenteringVStack>
      </Container>
    </ModelProfilePageLayout>
  );
};
